export default __webpack_public_path__ + "static/media/visualstudio-plain.5037e0b0.svg";